import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ValidationComponent } from './components/formulaire/validation/validation.component';
import { Routes as AppRoutes } from './models/routes.enum';
import { CoordonneesComponent } from './components/coordonnees/coordonnees.component';
import { ModificationCoordonneesComponent } from './components/formulaire/modification-coordonnees/modification-coordonnees.component';
import { BasculeHoganFiservComponent } from './components/bascule-hogan-fiserv/bascule-hogan-fiserv.component';
import { AccueilHoganComponent } from './components/accueil-hogan/accueil-hogan.component';
import { AccueilFiservComponent } from './components/accueil-fiserv/accueil-fiserv.component';
import { ModifierHoganComponent } from './components/formulaire/modification-hogan/modifier-hogan.component';
import { ModifierFiservComponent } from './components/formulaire/modification-fiserv/modifier-fiserv.component';
import { ValidationFiservComponent } from './components/formulaire/validation-fiserv/validation-fiserv.component';
import { PageConfirmationComponent } from './components/page-confirmation/page-confirmation.component';
import { PageErreurComponent } from './components/page-erreur/page-erreur.component';
import { RefreshGuardService } from './services/guard/refresh-guard.service';
import { PageValidationComponent } from './components/page-validation/page-validation.component';
import { ConfigMeta } from './models/meta';

export type HoganFiservRouteData = {
  componentHogan: Component;
  componentFiserv: Component;
};

const routesCredit: Routes = [
  {
    path: AppRoutes.RACINE,
    component: BasculeHoganFiservComponent,
    data: {
      componentHogan: AccueilHoganComponent,
      componentFiserv: AccueilFiservComponent,
    },
  },
  {
    path: AppRoutes.MODIFIER,
    component: BasculeHoganFiservComponent,
    data: {
      componentHogan: ModifierHoganComponent,
      componentFiserv: ModifierFiservComponent,
    },
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.VALIDATION,
    component: BasculeHoganFiservComponent,
    data: {
      componentHogan: ValidationComponent,
      componentFiserv: ValidationFiservComponent,
    },
    canActivate: [RefreshGuardService],
  },
  {
    path: AppRoutes.CONFIRMATION,
    component: PageConfirmationComponent,
    canActivate: [RefreshGuardService],
    data: { libelleHandle: 'credit' },
  },
  {
    path: AppRoutes.ERREUR,
    component: PageErreurComponent,
    canActivate: [RefreshGuardService],
    data: { libelleHandle: 'credit' },
  },
];

const routesBancaire: Routes = [
  {
    path: AppRoutes.RACINE,
    component: CoordonneesComponent,
  },
  {
    path: AppRoutes.MODIFIER,
    component: ModificationCoordonneesComponent,
  },
  {
    path: AppRoutes.CONFIRMATION,
    component: PageConfirmationComponent,
    data: { libelleHandle: 'coordonnees' },
  },
  {
    path: AppRoutes.VALIDATION,
    component: PageValidationComponent,
  },
  {
    path: AppRoutes.ERREUR,
    component: PageErreurComponent,
    canActivate: [RefreshGuardService],
    data: { libelleHandle: 'coordonnees' },
  },
];

const routesCreditSeulement: Routes = [
  ...routesCredit,
  { path: AppRoutes.ANY, redirectTo: AppRoutes.RACINE, pathMatch: 'full' },
];

const routesCreditEtBancaire: Routes = [
  {
    path: AppRoutes.COORDONNEES,
    children: routesBancaire,
  },
  {
    path: AppRoutes.CREDIT,
    children: routesCredit,
  },
  { path: AppRoutes.ANY, redirectTo: AppRoutes.COORDONNEES, pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      configuration.ConfigurationService.getConfig(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF) === 'true'
        ? routesCreditEtBancaire
        : routesCreditSeulement
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
